import Exception from '../lang/Exception'

export default class EmptyStackException extends Exception { }
